export default "__VITE_ASSET__BqYiZAjI__"